import { useAtomValue } from "jotai";
import React from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import {
  Box,
  VStack,
  Text,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import { useBreakpointValue } from "@whoosh/design-system/src/hooks/useBreakpointValue";

import { userTypeAtom } from "../atoms/eventSignUpProcess";

type FormStepHeaderProps = {
  title: string;
  smallScreenLeftComponent?: React.ReactNode;
  smallScreenRightComponent?: React.ReactNode;
};

/**
 *
 * Displays Form step header
 *
 * Note: Due to design differences - this only shows up
 * in the member app and the staff app
 * handles its own headers
 */
export const FormStepHeader = ({
  title,
  smallScreenLeftComponent,
  smallScreenRightComponent,
}: FormStepHeaderProps) => {
  const userType = useAtomValue(userTypeAtom);
  const shouldShowHeader = userType === "MEMBER";
  const isSmallScreen = useBreakpointValue({ base: true, md: false });
  const safeAreaInsets = useSafeAreaInsets();

  return shouldShowHeader ? (
    <VStack pb={6}>
      <Box
        visible={{ base: false, md: true }}
        width="100%"
        pt={6}
        px={6}
        alignItems="center"
      >
        <Text
          maxFontSizeMultiplier={2}
          fontFamily="Inter_600SemiBold"
          fontSize={16}
          fontWeight="normal"
          lineHeight={24}
        >
          {title}
        </Text>
      </Box>

      {isSmallScreen ? (
        <HStack px={6} style={{ paddingTop: safeAreaInsets.top }}>
          {smallScreenLeftComponent}
          <Box alignItems="center" justifyContent="center" flex={1}>
            <Text
              maxFontSizeMultiplier={2}
              fontFamily="Inter_600SemiBold"
              fontSize={16}
              fontWeight="normal"
              lineHeight={24}
            >
              {title}
            </Text>
          </Box>
          {smallScreenRightComponent}
        </HStack>
      ) : null}
    </VStack>
  ) : null;
};
